module.exports = __webpack_public_path__ + "img/bq.b551016f.svg";